const CACHE_PREFIX = 'qq_map_geocode_'
const CACHE_EXPIRE_DAYS = 7

function getCacheKey(address) {
  return CACHE_PREFIX + encodeURIComponent(address)
}

function getCachedLocation(address) {
  try {
    const cached = window.localStorage.getItem(getCacheKey(address))
    if (!cached) {
      return null
    }
    const { lat, lng, timestamp } = JSON.parse(cached)
    const expireTime = CACHE_EXPIRE_DAYS * 24 * 60 * 60 * 1000
    if (Date.now() - timestamp > expireTime) {
      window.localStorage.removeItem(getCacheKey(address))
      return null
    }
    return { lat, lng }
  } catch (e) {
    return null
  }
}

function setCachedLocation(address, location) {
  try {
    window.localStorage.setItem(getCacheKey(address), JSON.stringify({
      ...location,
      timestamp: Date.now()
    }))
  } catch (e) {
    // localStorage 写失败时不影响主流程
  }
}

/**
 * 腾讯地图地址解析（WebService API）
 * 通过地址文本获取经纬度，用于地图初始化定位
 * 同一地址会缓存 7 天，避免反复调用接口
 * @param {string} address 地址文本，如 "贵州省遵义市习水县"
 * @param {string} key 腾讯地图 Key
 * @returns {Promise<{lat: number, lng: number}>}
 */
export function geocodeAddress(address, key) {
  return new Promise((resolve, reject) => {
    if (!key) {
      reject(new Error('腾讯地图 Key 未配置'))
      return
    }
    if (!address) {
      reject(new Error('地址为空'))
      return
    }

    // 先读缓存，命中则直接返回
    const cached = getCachedLocation(address)
    if (cached) {
      resolve(cached)
      return
    }

    // 后端返回的 areaName 格式为 "省-市-区县"，去掉横杠便于地址解析
    const cleanAddress = address.replace(/-/g, '')

    const callbackName = 'qqMapGeocoderCallback' + Math.floor(Math.random() * 1000000)
    const script = document.createElement('script')
    script.src = `https://apis.map.qq.com/ws/geocoder/v1/?address=${encodeURIComponent(cleanAddress)}&key=${key}&output=jsonp&callback=${callbackName}`

    const cleanup = () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script)
      }
      delete window[callbackName]
    }

    window[callbackName] = (data) => {
      cleanup()
      if (data && data.status === 0 && data.result && data.result.location) {
        const location = {
          lat: data.result.location.lat,
          lng: data.result.location.lng
        }
        setCachedLocation(address, location)
        resolve(location)
      } else {
        reject(new Error((data && data.message) || '地址解析失败'))
      }
    }

    script.onerror = () => {
      cleanup()
      reject(new Error('地址解析服务加载失败'))
    }

    document.head.appendChild(script)
  })
}
